module.exports = __webpack_public_path__ + "img/Notification.770531ca.svg";